import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { get as getTheme } from 'Components/Base/constants';
import { useConfig } from 'Context/ConfigContext';

import { Box, Flex, Text, SvgIcon } from '../../Base';
import { QUIZ_VARIANTS } from '../constant';

const Table = styled((props) => <Box as="table" {...props} />)`
  border-collapse: collapse;
  width: 100%;
`;
const TableHead = styled((props) => <Box as="thead" {...props} />)`
  background-color: rgba(216, 216, 216, 0.2);
`;

const TableBody = styled((props) => <Box as="tbody" {...props} />)`
  background-color: white;
`;

const TableRow = styled((props) => <Box as="tr" {...props} />)``;

// is: 'th' won't work anymore because Text no longer built from system-components or rebass
const TableHeadCell = styled((props) => <Text textStyle={'body2'} as="th" {...props} />)`
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
`;
// TableHeadCell.defaultProps = {
//   // is: 'th',
//   textAlign: 'center',
//   color: 'white',
//   py: 3,
// };

const TableCell = styled((props) => <Text textStyle={'body2'} as="td" {...props} />)`
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  font-weight: 400;
`;
// TableCell.defaultProps = {
//   // is: 'td',
//   textAlign: 'center',
//   color: 'white',
//   py: 3,
// };

const Badge = styled(Flex)`
  align-items: center;
  justify-content: center;
  border-radius: 100px;
`;

const StyledBox = styled(Box)`
  @media screen and (max-width: ${getTheme('breakpoints.sm')}) {
    td,
    th {
      font-size: 12px;
    }
  }
`;

const ReportTableBox = ({ variant, children, ...props }) => {
  switch (variant) {
    case QUIZ_VARIANTS.GRADED_EXAM:
      return <StyledBox {...props}>{children}</StyledBox>;
    default:
      return <Box {...props}>{children}</Box>;
  }
};

const ReportTableHead = ({ variant, showPassingCriteria, allowPreviousAnswersView }) => {
  switch (variant) {
    case QUIZ_VARIANTS.GRADED_EXAM:
      return (
        <TableHead>
          <TableRow>
            <TableHeadCell color={'text'}>รอบ</TableHeadCell>
            <TableHeadCell color={'text'}>วันที่/เวลา</TableHeadCell>
            {showPassingCriteria && <TableHeadCell color={'text'}>ผลสอบ</TableHeadCell>}
            <TableHeadCell color={'text'}>คะแนน</TableHeadCell>
            {allowPreviousAnswersView && <TableHeadCell />}
          </TableRow>
        </TableHead>
      );
    default:
      return (
        <TableHead>
          <TableRow>
            <TableHeadCell color={'white'}>รอบที่</TableHeadCell>
            <TableHeadCell color={'white'}>วัน/เวลา</TableHeadCell>
            <TableHeadCell color={'white'}>คะแนน</TableHeadCell>
            <TableHeadCell />
          </TableRow>
        </TableHead>
      );
  }
};

ReportTableHead.propTypes = {
  allowPreviousAnswersView: PropTypes.bool,
  showPassingCriteria: PropTypes.bool,
  variant: PropTypes.string,
};

const ReportTableCells = ({
  variant,
  showPassingCriteria,
  allowPreviousAnswersView,
  reports,
  passingScore,
  onSeeReport,
}) => {
  switch (variant) {
    case QUIZ_VARIANTS.GRADED_EXAM:
      return (
        <TableBody>
          {reports.map((r) => {
            const { round, altDate, score, fullScore, id } = r;
            return (
              <TableRow key={id} onClick={() => allowPreviousAnswersView && onSeeReport(id, round)}>
                <TableCell color={'text'}>{round}</TableCell>
                <TableCell color={'text'}>{altDate}</TableCell>
                {showPassingCriteria && (
                  <TableCell>
                    <Flex alignItems={'center'} justifyContent={'center'}>
                      {score >= passingScore ? (
                        <Badge
                          width={{ _: 50, sm: 70 }}
                          height={{ _: 18, sm: 24 }}
                          backgroundColor="#C7FFE0"
                          color={'success'}
                        >
                          ผ่าน
                        </Badge>
                      ) : (
                        <Badge
                          width={{ _: 50, sm: 70 }}
                          height={{ _: 18, sm: 24 }}
                          backgroundColor="#FBDFDF"
                          color={'danger'}
                        >
                          ไม่ผ่าน
                        </Badge>
                      )}
                    </Flex>
                  </TableCell>
                )}
                <TableCell color={'text'}>{`${score ?? ' - '}/${fullScore}`}</TableCell>
                {allowPreviousAnswersView && (
                  <TableCell>
                    <Flex alignItems={'center'} justifyContent={'center'}>
                      <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} size={20} />
                    </Flex>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      );
    case QUIZ_VARIANTS.OFFICIAL_EXAM:
      return (
        <TableBody>
          {reports.map((r) => {
            const { round, date, score, fullScore, id } = r;
            const hasScore = score !== null && score !== undefined;
            return (
              <TableRow key={id}>
                <TableCell>{round}</TableCell>
                <TableCell>{date}</TableCell>
                <TableCell>{`${score ?? ' - '}/${fullScore}`}</TableCell>
                {hasScore && (
                  <TableCell onClick={() => onSeeReport(id, round)}>
                    <Flex alignItems={'center'} justifyContent={'center'}>
                      <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} size={24} />
                    </Flex>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      );
    default:
      return (
        <TableBody>
          {reports.map((r) => {
            const { round, date, score, fullScore, id } = r;
            return (
              <TableRow key={id} onClick={() => onSeeReport(id, round)}>
                <TableCell>{round}</TableCell>
                <TableCell>{date}</TableCell>
                <TableCell>{`${score ?? ' - '}/${fullScore}`}</TableCell>
                <TableCell>
                  <Flex alignItems={'center'} justifyContent={'center'}>
                    <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} size={24} />
                  </Flex>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      );
  }
};

ReportTableCells.propTypes = {
  allowPreviousAnswersView: PropTypes.bool,
  onSeeReport: PropTypes.func,
  passingScore: PropTypes.number,
  reports: PropTypes.arrayOf(
    PropTypes.shape({
      round: PropTypes.number,
      date: PropTypes.string,
      score: PropTypes.number,
      fullScore: PropTypes.number,
      id: PropTypes.string,
    })
  ),
  showPassingCriteria: PropTypes.bool,
  variant: PropTypes.string,
};

ReportTableCells.defaultProps = {
  reports: [],
  onSeeReport: () => {},
};

const ReportTable = ({ reports, passingScore, onSeeReport, variant, ...restProps }) => {
  const {
    classroom: { quiz },
  } = useConfig();
  const { showPassingCriteria = true, allowPreviousAnswersView = false } = quiz?.gradedExam ?? {};
  return (
    <ReportTableBox
      variant={variant}
      width={'100%'}
      maxWidth={595}
      style={{
        overflow: 'auto',
        border: 'solid 1px rgba(216, 216, 216, 0.4)',
        borderRadius: '8px',
      }}
      {...restProps}
    >
      <Table>
        <ReportTableHead
          variant={variant}
          allowPreviousAnswersView={allowPreviousAnswersView}
          showPassingCriteria={showPassingCriteria}
        />
        <ReportTableCells
          variant={variant}
          allowPreviousAnswersView={allowPreviousAnswersView}
          showPassingCriteria={showPassingCriteria}
          reports={reports}
          passingScore={passingScore}
          onSeeReport={onSeeReport}
        />
      </Table>
    </ReportTableBox>
  );
};

ReportTable.propTypes = {
  reports: PropTypes.arrayOf(
    PropTypes.shape({
      round: PropTypes.number,
      date: PropTypes.string,
      score: PropTypes.number,
      fullScore: PropTypes.number,
      id: PropTypes.string,
    })
  ),
  onSeeReport: PropTypes.func,
  variant: PropTypes.string,
  passingScore: PropTypes.number,
};
ReportTable.defaultProps = {
  reports: [],
  onSeeReport: () => {},
};

export default ReportTable;
